/** @format */

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { SimpleSelect } from './SimpleSelect';
import { TariffsLoader } from '../../modules/tariffs/TariffsLoader';
import { tariffConstants } from '../../modules/tariffs/actions';
import { Auth } from '../../modules/auth/Auth';

type TariffSelectProps = {
    dispatchName?: string;
    required: boolean;
    label: string;
    selectedValue?: string | number;
    type: number;
    callback?: (e: any) => void;
};

const TariffSelect = (props: TariffSelectProps): React.ReactElement => {
    const dispatch = useDispatch();
    const [tariffs, setTariffs] = useState<Array<HeaderCheckBoxSelectListElement>>([]);
    const type = props.type;
    const itemLoaders = useMemo(() => {
        return new ItemLoaders(dispatch);
    }, [dispatch]);
    const tariffLoader = useMemo(() => {
        return new TariffsLoader(itemLoaders);
    }, [itemLoaders]);

    const updateTariffs = useCallback((): void => {
        setTariffs(tariffLoader.getHeaderList());
    }, [tariffLoader]);

    useEffect(() => {
        tariffLoader.loadTariffs({
            filters: [
                { name: 'customerId', value: Auth.getUserPlatformResellerId() },
                { name: 'deleted', value: false },
                { name: 'type', value: type },
                { name: 'itemsPerPage', value: 9999 },
            ],
            orders: [],
            callback: () => {
                updateTariffs();
            },
        });
    }, [dispatch, updateTariffs, tariffLoader, type]);

    if (tariffs.length > 0) {
        return (
            <SimpleSelect
                dispatchName={props.dispatchName ?? tariffConstants.SELECT}
                label={props.label}
                required={props.required}
                elements={tariffs}
                callback={props.callback}
                selectedValue={props.selectedValue}
            />
        );
    }

    return <></>;
};

export default TariffSelect;
